module.exports = __webpack_public_path__ + "static/media/6.48175820.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row5/6.wav
// module id = 90
// module chunks = 0